import { useLocalStorage } from "../../../../../shared/hooks/useLocalStorage";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";
import { useCallback } from "react";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces";

export const IDENTITY_VERIFICATION_REQUIREMENT_EVENT = {
  StartVerification: "StartVerification",
  CompleteVerification: "CompleteVerification"
} as const;

const getKey = (
  requirement: IRequirementResponse,
  identityVerificationRequest: IIdentityVerificationRequestResponse | undefined
): string => {
  return `${requirement.dataSourceId} ${identityVerificationRequest?.identityVerification?.identityVerificationId}`;
};

export const useIDVPendingSuccessStatus = () => {
  const [pendingSuccessRequirements, setPendingSuccessRequirements] =
    useLocalStorage<Record<string, Date>>(
      "identityVerificationPendingSuccessRequirements",
      {}
    );

  const setPendingSuccessStatus = useCallback(
    (
      requirement: IRequirementResponse,
      identityVerificationRequest:
        | IIdentityVerificationRequestResponse
        | undefined
    ) => {
      setPendingSuccessRequirements(prevState => ({
        ...prevState,
        [getKey(requirement, identityVerificationRequest)]: new Date()
      }));
    },
    [setPendingSuccessRequirements]
  );

  const getIsPendingSuccessStatus = useCallback(
    (
      requirement: IRequirementResponse,
      identityVerificationRequest:
        | IIdentityVerificationRequestResponse
        | undefined
    ) => {
      const pendingSuccessStartedAt =
        pendingSuccessRequirements[
          getKey(requirement, identityVerificationRequest)
        ];

      const timeDiff = pendingSuccessStartedAt
        ? Date.now() - new Date(pendingSuccessStartedAt).getTime()
        : 0;

      const FiveMinutes = 5 * 60 * 1000;

      return (
        pendingSuccessStartedAt &&
        identityVerificationRequest?.status ===
          IdentityVerificationRequestStatus.Pending &&
        timeDiff < FiveMinutes
      );
    },
    [pendingSuccessRequirements]
  );

  return {
    setPendingSuccessStatus,
    getIsPendingSuccessStatus
  };
};
